// src/Home.js 
import React from 'react'
import BucketApp from "./components/BucketApp";
import CNTower from "./app/images/cntower.jpg";

const Home = () => {
  return (
    <div className="container">
    <h1 className="is-size-3 has-text-weight-bold has-text-link has-text-centered">Home</h1>
	<img src={CNTower} className="img_responsive" alt="CN Tower" title="CN Tower" />
	  <p>See my <strong>Bucket List App</strong> below.  It's uses the <strong><em>To Do</em></strong> RESTful API kindly supplied by <a href="https://jsonplaceholder.typicode.com/">JSON Placeholder</a>.  I will swop this out for my own Bucket List API in a couple weeks, after I have made the time to build and deploy my own API.</p><br />
	  
	  <BucketApp />
	  <br />
	  
	  <p>Cat o'nine tails snow matey six pounders come about wherry. Davy Jones' Locker bring a spring upon her cable jack matey Yellow Jack measured fer yer chains. Scurvy Shiver me timbers long boat chase guns ahoy keel. Ahoy warp draft scourge of the seven seas rum yawl.</p><br />
    <p>Hands measured fer yer chains Jolly Roger Gold Road hornswaggle yard. Square-rigged quarterdeck Plate Fleet broadside yardarm bilge. Gangplank lanyard square-rigged parley measured fer yer chains lad. Piracy spanker careen heave to trysail dead men tell no tales. </p><br />
    <p>Maroon bring a spring upon her cable hearties gun port transom. Cackle fruit avast trysail provost barque strike colors. Code of conduct fire in the hole crimp dead men tell no tales no prey, no pay boatswain. Lass bilge rat provost lee topgallant gangway. </p>
	</div>
  )
}

export default Home